import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import { monthOptions, yearOptions } from "../../../config";
import { buildSheet, tableConfig } from "./config";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import { saveAs } from "file-saver";
//type = unit_entri || service

export default class LaporanUnitHarian extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = Number(moment().format("MM"));
    this.currentYear = Number(moment().format("YYYY"));

    this.state = {
      month: monthOptions.find((item) => item.value === this.currentMonth),
      year: yearOptions.find((item) => item.value === this.currentYear),
      dataTable: [],
      search: {
        year: this.currentYear,
        month: this.currentMonth,
      },
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    const currCabang = this.props.kodeCabang?.value;
    const prevCabang = prevProps?.kodeCabang?.value;
    if (currCabang !== prevCabang) {
      this.fetchData();
    }
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    this.setState(
      (prev) => ({
        ...prev,
        search: {
          month: prev.month?.value,
          year: prev?.year?.value,
        },
      }),
      () => this.fetchData(),
    );
  };

  exportExcel = async ({ reqBody, title, setError }) => {
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
      setError,
      menuName: `Dashboard Kabeng Keatas - ${title}`,
      args: reqBody,
    });

    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${reqBody.filename}.xlsx`);
    }

    return res.ok;
  };

  handlePrint = async () => {
    const { onTriggerLoading, type, setError } = this.props;
    const { dataTable } = this.state;

    const titleMap = {
      service: "Unit Servis Harian By Mekanik",
      unit_entri: "Laporan Unit Entri Harian By Mekanik",
    };

    const title = titleMap[type];
    const fileName = title.replace(/\s+/g, "_");

    const datasets = [
      {
        key: "sa",
        label: "Tim Service Advisor",
        suffix: "SA",
        data: this.constructData(dataTable.sa || []),
      },
      {
        key: "mechanic",
        label: "Tim Mekanik",
        suffix: "MECHANIC",
        data: this.constructData(dataTable.mechanic || []),
      },
    ];

    onTriggerLoading();

    await Promise.all(
      datasets.map(({ label, suffix, data }) =>
        this.exportExcel({
          title,
          setError,
          reqBody: {
            filename: `${fileName}_${suffix}`,
            sheets: [
              buildSheet({
                title: `${title} - ${suffix}`,
                nameLabel: label,
                data,
              }),
            ],
          },
        }),
      ),
    );

    onTriggerLoading();
  };

  fetchData = async () => {
    const { setError, onTriggerLoading, kodeCabang, type } = this.props;
    const { month, year } = this.state;
    const userId = localStorage.getItem("userId");
    if (!kodeCabang?.value) return;

    onTriggerLoading();

    const fn =
      type === "unit_entri"
        ? "getLaporanUnitEntryHarianByMekanikH23"
        : "getLaporanUnitServiceHarianByMekanikH23";
    const title =
      type === "unit_entri"
        ? "Laporan Unit Entri Harian"
        : "Laporan Unit Servis Harian";
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO")[fn],
      setError: setError,
      menuName: `Dashboard Level Kabeng Keatas - ${title}`,
      args: {
        kodeCabang: kodeCabang?.value,
        month: month?.value,
        year: year?.value,
        idUser: userId,
        type: "KABENG",
      },
    });

    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: res.data.data,
      });
    }
  };

  constructData = (data = []) => {
    return data.map(({ totalDaily, ...rest }) => ({
      ...totalDaily,
      ...rest,
    }));
  };

  renderTable = () => {
    const { dataTable, config, search } = this.state;
    if (Object.values(dataTable).every((item) => !item)) {
      return (
        <SimpleDataTable
          data={[]}
          columns={config}
          options={{ pagination: false }}
        />
      );
    }

    return Object.keys(dataTable || {}).map((key) => {
      if (!dataTable[key]) return null;
      const title = key === "sa" ? "Tim Service Advisor" : "Tim Mekanik";
      return (
        <div className="margin-top-20px" key={`table-${key}`}>
          <SimpleDataTable
            data={this.constructData(dataTable[key])}
            columns={tableConfig(search?.year, search?.month, title)}
            options={{ pagination: false }}
          />
        </div>
      );
    });
  };

  render() {
    const { month, year } = this.state;

    return (
      <React.Fragment>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            className="margin-bottom-15px"
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        {this.renderTable()}
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton text="CETAK" onClick={() => this.handlePrint()} />
        </FlexView>
      </React.Fragment>
    );
  }
}
